/**
 * This method checks the passed string with the defined length
 * @param string
 * @param len
 * @returns {boolean}
 */
export const checkStringLength = (str: any, len: any) => {
  if (str) {
    return str.length > len;
  }
  return false;
};

/**
 * This method create a substring using a given string
 * @param value
 * @param length
 * @returns {null|*}
 */
export const changeStringLength = (value: any, length: any) => {
  if (value) {
    return !checkStringLength(value, length)
      ? value
      : `${value.substring(0, length)}...`;
  }
  return null;
};
